import { Pipe, PipeTransform } from '@angular/core';
import { Address } from '../../model/address.model';

@Pipe({
    name: 'friendlyAddress'
})
export class FriendlyAddressPipe implements PipeTransform {

    transform(addresses: Address[] | Address) {
        if (!addresses) {
            return undefined;
        }
        if (!Array.isArray(addresses)) {
            return getLabel(addresses);
        }
        return (addresses as Address[]).map(address => ({ label: getLabel(address), value: address }));
    }

}

const getLabel = (address) => address.line1 +
    (address.townOrCity !== '' ? ', ' + address.townOrCity : address.townOrCity) +
    (address.country !== '' ? ', ' + address.country : address.country) +
    (address.postCode !== '' ? ', ' + address.postCode : address.postCode);
